import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { LogComponent } from './log.component';
import { LogDetailComponent } from './log-detail.component';
import { LogPopupComponent } from './log-dialog.component';
import { LogDeletePopupComponent } from './log-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class LogResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const logRoute: Routes = [
  {
    path: 'log',
    component: LogComponent,
    resolve: {
      'pagingParams': LogResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.log.home.title'
    }
  }, {
    path: 'log/:id',
    component: LogDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.log.home.title'
    }
  }
];

export const logPopupRoute: Routes = [
  {
    path: 'log-new',
    component: LogPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.log.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'log/:id/edit',
    component: LogPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.log.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'log/:id/delete',
    component: LogDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.log.home.title'
    },
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/log/log.route.ts